
import { useState } from 'react';

export default function SkillsProgrammesSection() {
  const [isExpanded, setIsExpanded] = useState(false);

  const programmes = [
    {
      title: 'Checkout Operator Level 2',
      code: '27/SP-523101/Che2/00239',
      unitStandards: [
        'US 114903 | NQF 2 | 8 Credits | Interact with customers',
        'US 114889 | NQF 2 | 8 Credits | Record transactions',
        'US 114894 | NQF 2 | 10 Credits | Process payment at a Point of Sales'
      ],
      nqfLevel: 'NQF 2',
      credits: '26 Credits'
    },
    {
      title: 'Shelf Filler / General Merchandiser (Stock Counter) Level 2',
      code: '27/SP-833401/SHE2/00238',
      unitStandards: [
        'US 114903 | NQF 2 | 8 Credits | Interact with customers',
        'US 114906 | NQF 2 | 10 Credits | Mark merchandise and maintain displays',
        'US 114891 | NQF 2 | 5 Credits | Count stock for a stock-take'
      ],
      nqfLevel: 'NQF 2',
      credits: '23 Credits'
    },
    {
      title: 'Shelf Filler (General) Level 2',
      code: '27/SP-833401/She2/00237',
      unitStandards: [
        'US 114895 | NQF 2 | 10 Credits | Define the core concepts of the Wholesale and Retail environment',
        'US 117887 | NQF 2 | 5 Credits | Complete Basic Business Calculations',
        'US 114912 | NQF 2 | 10 Credits | Maintain a safe and secure Wholesale and Retail environment'
      ],
      nqfLevel: 'NQF 2',
      credits: '25 Credits'
    },
    {
      title: 'Small Business Manager/Owner (Finance) Level 3',
      code: '27/SP-134903/Sma3/00301',
      unitStandards: [
        'US 243810 | NQF 3 | 12 Credits | Control cash in a small business',
        'US 119666 | NQF 2 | 8 Credits | Determine financial requirements of a new venture',
        'US 119674 | NQF 2 | 10 Credits | Manage finances for a new venture',
        'US 13932 | NQF 3 | 5 Credits | Prepare and process documents for financial and banking processes'
      ],
      nqfLevel: 'NQF 3',
      credits: '35 Credits'
    },
    {
      title: 'SYL/SP/003/2021 Management Development Programme',
      unitStandards: [
        'US 13917 | NQF 4 | 6 Credits | Identify responsibilities of a team leader in ensuring that organisational standards are met',
        'US 242829 | NQF 4 | 5 Credits | Monitor the level of service to a range of customers',
        'US 11473 | NQF 4 | 8 Credits | Manage individual and team performance',
        'US 13952 | NQF 4 | 8 Credits | Demonstrate basic understanding of the Primary labour legislation that impacts on a business'
      ],
      nqfLevel: 'NQF 4',
      credits: '27 Credits'
    },
    {
      title: 'SP/004/SYL/CC01 Professional Conduct for Management Role',
      unitStandards: [
        'US 242816 | NQF 4 | 5 Credits | Conduct a structured meeting',
        'US 242815 | NQF 4 | 5 Credits | Apply the organisation\'s code of conduct in a work environment',
        'US 242813 | NQF 4 | 5 Credits | Explain the contribution made by own area of responsibility to the overall organisational strategy',
        'US 242818 | NQF 4 | 5 Credits | Describe the relationship of junior management to other management roles'
      ],
      nqfLevel: 'NQF 4',
      credits: '20 Credits'
    },
    {
      title: 'SYL/SP/002/2020 Supervisory Development Programme',
      unitStandards: [
        'US 242824 | NQF 4 | 12 Credits | Apply leadership concepts in a work context',
        'US 242822 | NQF 4 | 10 Credits | Employ a systematic approach to achieving objectives',
        'US 242810 | NQF 4 | 6 Credits | Manage expenditure against a budget',
        'US 242819 | NQF 4 | 10 Credits | Motivate and build a team',
        'US 242811 | NQF 4 | 5 Credits | Prioritise time and work for self and team',
        'US 116932 | NQF 4 | 8 Credits | Solve problems, make decisions and implement solutions'
      ],
      nqfLevel: 'NQF 4',
      credits: '45 Credits'
    },
    {
      title: 'Management Essentials Programme',
      unitStandards: [
        'US 242824 | NQF 4 | 12 Credits | Apply leadership concepts in a work context',
        'US 242822 | NQF 4 | 10 Credits | Employ a systematic approach to achieving objectives',
        'US 242819 | NQF 4 | 10 Credits | Motivate and build a team',
        'US 242811 | NQF 4 | 5 Credits | Prioritise time and work for self and team'
      ],
      nqfLevel: 'NQF 4',
      credits: '37 Credits'
    }
  ];

  return (
    <div className="mb-12">
      <div 
        className="bg-white rounded-lg shadow-md border border-gray-200 cursor-pointer"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="p-6 flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold text-[#1A1A1A] mb-2">
              Skills Programmes
            </h2>
            <p className="text-gray-600">
              Short-term focused training to develop specific competencies
            </p>
          </div>
          <i className={`ri-arrow-${isExpanded ? 'up' : 'down'}-s-line text-2xl text-[#2D7F3E]`}></i>
        </div>
      </div>

      {isExpanded && (
        <div className="mt-4 bg-white rounded-lg shadow-md border border-gray-200">
          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {programmes.map((programme, index) => (
                <div key={index} className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
                  <div className="flex items-start justify-between mb-3">
                    <h3 className="text-lg font-semibold text-[#1A1A1A] flex-1">
                      {programme.title}
                    </h3>
                    <span className="bg-[#2D7F3E] text-white text-xs px-2 py-1 rounded-full ml-2">
                      {programme.nqfLevel}
                    </span>
                  </div>

                  <div className="mb-4">
                    <h4 className="text-sm font-medium text-gray-700 mb-2">Unit Standards:</h4>
                    <ul className="space-y-1">
                      {programme.unitStandards.map((standard, idx) => (
                        <li key={idx} className="text-xs text-gray-600 flex items-start">
                          <i className="ri-check-line text-[#2D7F3E] mr-1 mt-0.5 flex-shrink-0"></i>
                          <span>{standard}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="space-y-2 text-sm mb-4">
                    {programme.code && (
                      <div className="flex justify-between gap-4">
                        <span className="text-gray-500">Code:</span>
                        <span className="font-medium text-right break-words">{programme.code}</span>
                      </div>
                    )}
                    <div className="flex justify-between">
                      <span className="text-gray-500">Credits:</span>
                      <span className="font-medium">{programme.credits}</span>
                    </div>
                  </div>

                  <button className="w-full btn btn-primary btn-sm">
                    Request Info
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
